import { render, staticRenderFns } from "./MoneyDetail.vue?vue&type=template&id=a4d77400&scoped=true&"
import script from "./MoneyDetail.vue?vue&type=script&lang=js&"
export * from "./MoneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoneyDetail.vue?vue&type=style&index=0&id=a4d77400&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d77400",
  null
  
)

export default component.exports